import { useEffect, useState } from 'react';
import Header from './header';
import Footer from './footer';
import { companyName } from '../../../utils';


export default function Layout({ children, title }) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  useEffect(() => {
    window.document.title = title + ' - ' + companyName();
  }, [title]);

  console.log(searchTerm);
  return (
    <div style={{ minHeight: '100vh' }}>
      <Header onSearch={handleSearch} />
      {children}
      <Footer />
    </div>
  );
}
